import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Product} from "../../../Model/Catalog/Product";

@Component({
  selector: 'np-product-sellthroughfigures',
  standalone: false,
  templateUrl: './product-sellthroughfigures.component.html',
  styleUrl: './product-sellthroughfigures.component.css'
})
export class ProductSellthroughfiguresComponent {
  @Input() model: Product;
  @Input() showDragHandle: boolean = false;
  @Input() dragFilter: string = 'noDrag';
  @Input() selectedElements: string[] = [''];
  @Input() templateView: boolean = false;
  @Output() elementSelected = new EventEmitter<string>();
  @Output() excelElementDropped = new EventEmitter<any>();

  templateSelect(identifier: string, system: string) {
    this.elementSelected.emit(identifier);
  }

  excelElementDrop(event: any) {
    this.excelElementDropped.emit(event);
  }
}
